import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { querySvipUserRightValueProps } from '@/views/user/member/service';

const CUSTOMER_KEY = 'React-ts-ant-customer';

const localCustomer = LocalStore.getValue<querySvipUserRightValueProps>(CUSTOMER_KEY) || {};

export const defaults: querySvipUserRightValueProps = {
  rightState: 0,
  rightValue: 0,
  svipLevel: '',
  rightBanFlag: false,
  ...localCustomer
};

const SVIP_CUSTOMER_KEY = 'React-ts-ant-CUSTOMER';

export const updateCustomer: (customer: querySvipUserRightValueProps) => IAction<querySvipUserRightValueProps> = (
  customer: querySvipUserRightValueProps
) => ({
  type: SVIP_CUSTOMER_KEY,
  payload: customer
});

const customerReducer: Reducer<querySvipUserRightValueProps, IAction<any>> = (
  state = defaults,
  action: IAction<any>
) => {
  const { type, payload } = action;

  switch (type) {
    case SVIP_CUSTOMER_KEY:
      LocalStore.setValue(CUSTOMER_KEY, payload as querySvipUserRightValueProps);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default customerReducer;
